
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Punetaxihire() {



    const cardData =
    {
        keyword: ' Pune Taxi Hire',
        heading: 'Mauli Cabs:  Pune Taxi Hire',
        headingDescription: 'Mauli Cabs offers convenient and reliable Pune taxi hire services, ensuring a comfortable and hassle-free travel experience across the city and beyond. Whether you are looking for a quick city ride, a family outing, or a long-distance trip, we provide a variety of vehicles including sedans, SUVs, and premium cars to suit your needs. With professional drivers, transparent pricing, no hidden charges, and a commitment to safety, Mauli Cabs guarantees a smooth and enjoyable ride every time you hire a taxi in Pune.',

        top: 'Top Places to Visit in Pune with Mauli Cabs',

"topPlaces": [
    {
        "title": "Shaniwar Wada",
        "description": "Shaniwar Wada is a historical fortification in Pune, built in 1732. It was the seat of the Peshwas until 1818 and is famous for its architecture and the mystery surrounding its history. The fort also hosts a light and sound show in the evenings."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Aga Khan Palace, built in 1892, is an architectural masterpiece with a significant historical background. It was the place where Mahatma Gandhi and his wife Kasturba were imprisoned during the Quit India Movement. The palace now houses a museum dedicated to Gandhiji."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Located about 35 km from Pune, Sinhagad Fort is a popular trekking destination known for its historical significance and stunning views of the surrounding Sahyadri hills. It is also famous for its food stalls, especially the 'Kanda Bhaji' (onion fritters)."
    },
    {
        "title": "Shreemant Dagdusheth Halwai Ganapati Temple",
        "description": "One of the most famous Ganesh temples in Pune, Dagdusheth Halwai Ganapati Temple is known for its grandeur and the devotion it attracts, especially during Ganesh Chaturthi. The idol of Lord Ganesh here is one of the richest and most revered in India."
    },
    {
        "title": "Osho Ashram",
        "description": "The Osho Ashram in Pune is an international meditation resort that offers various courses, therapies, and meditation sessions. It’s a peaceful retreat for those seeking relaxation, spiritual guidance, or personal growth."
    },
    {
        "title": "Katraj Snake Park",
        "description": "The Katraj Snake Park, situated on the outskirts of Pune, is home to various species of snakes and other reptiles. The park also features a zoo and a museum showcasing wildlife and reptiles, making it an educational destination for families."
    },
    {
        "title": "Pune Okayama Friendship Garden (Pu La Deshpande Garden)",
        "description": "A serene Japanese-style garden located on the banks of the Mula-Mutha river, the Okayama Friendship Garden is ideal for leisurely walks amidst nature. The garden is a beautiful blend of lush greenery, ponds, and Japanese-style landscaping."
    },
    {
        "title": "Pune University Campus (Savitribai Phule Pune University)",
        "description": "The Pune University campus is known for its beautiful architecture, lush green landscapes, and historic buildings. It is one of the oldest universities in India and a peaceful place to visit, walk, and admire the scenic beauty."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "The Raja Dinkar Kelkar Museum in Pune is home to an extensive collection of artifacts, sculptures, and traditional crafts. It showcases the rich cultural history of India and is a must-visit for history and art lovers."
    },
    {
        "title": "Fergusson College",
        "description": "Fergusson College, established in 1885, is one of Pune's oldest and most prestigious educational institutions. The campus is known for its beautiful colonial-style architecture, making it a historical landmark in the city."
    }
],

"services": [
    {
      "name": "Pune Airport Taxi Hire",
      "description": "Book Pune Airport Taxi Hire for timely, comfortable, and affordable transportation to and from Pune International Airport. Our professional drivers ensure a smooth ride."
    },
    {
      "name": "Pune Corporate Taxi Hire",
      "description": "Book Pune Corporate Taxi Hire for business-related travel. Our fleet offers comfortable and professional services to meet the needs of corporate executives."
    },
    {
      "name": "Luxury Taxi Hire Pune",
      "description": "Enjoy a luxury ride in Pune with our Luxury Taxi Hire service. Choose from premium vehicles for your corporate events, parties, or special occasions."
    },
    {
      "name": "Pune Outstation Taxi Hire",
      "description": "Mauli Cabs offers Pune Outstation Taxi Hire for seamless travel to nearby cities. Whether it's a quick trip or a weekend getaway, we provide the perfect ride."
    },
    {
      "name": "Pune Local Taxi Rentals",
      "description": "Book Pune Local Taxi Rentals for city sightseeing, shopping trips, or local transportation needs. Our reliable taxis ensure a hassle-free experience."
    },
    {
      "name": "Pune Wedding Taxi Service",
      "description": "Book a Pune Wedding Taxi Service for your big day. We provide luxury vehicles, decorated taxis, and professional chauffeurs for wedding events and related ceremonies."
    },
    {
      "name": "Pune Taxi Hire for Tours",
      "description": "Explore Pune with our Taxi Hire for Tours. Whether it's a city tour or a nearby destination, we offer comfortable and reliable taxis to enhance your experience."
    },
    {
      "name": "Economy Taxi Hire Pune",
      "description": "Opt for Economy Taxi Hire in Pune for affordable, no-frills transportation. Perfect for short trips, local commutes, and budget-conscious travelers."
    },
    {
      "name": "Pune Taxi Hire for Events",
      "description": "Make your events more special by booking a Pune Taxi Hire. Whether it's a corporate event, party, or conference, we provide comfortable transportation for groups."
    },
    {
      "name": "Pune 24/7 Taxi Service",
      "description": "Mauli Cabs offers Pune 24/7 Taxi Service for all your transportation needs. Book a taxi anytime, anywhere, and we’ll ensure a prompt and safe ride."
    },
    {
      "name": "Pune Taxi Hire",
      "description": "For a reliable and affordable ride in Pune, choose Pune Taxi Hire services. Whether you're going for a business meeting, shopping, or a city tour, we’ve got you covered."
    },
    {
      "name": "Pune to Mumbai Airport Cab",
      "description": "Book a Pune to Mumbai Airport Cab for a stress-free, timely ride. Our professional drivers ensure you reach Mumbai International Airport on time, with comfort."
    },
    {
      "name": "Pune to Mumbai Cabs",
      "description": "Travel comfortably with Pune to Mumbai Cabs. Our fleet offers both economy and luxury options, ensuring a smooth journey between Pune and Mumbai."
    },
    {
      "name": "Pune to Mumbai Cheapest Cab",
      "description": "Looking for an affordable ride from Pune to Mumbai? Book the Pune to Mumbai Cheapest Cab and enjoy budget-friendly travel without compromising on comfort."
    },
    {
      "name": "Pune to Mumbai Cab Service",
      "description": "Book Pune to Mumbai Cab Service for a hassle-free, comfortable, and safe journey between the two cities. We provide one-way and round-trip options."
    },
    {
      "name": "Cab from Pune to Mahabaleshwar",
      "description": "Book a Cab from Pune to Mahabaleshwar with Mauli Cabs. Enjoy a scenic and comfortable ride to Mahabaleshwar, whether for a quick getaway or sightseeing."
    },
    {
      "name": "Taxi From Pune to Mahabaleshwar",
      "description": "Book a Taxi from Pune to Mahabaleshwar for a relaxing and comfortable journey. We provide affordable, reliable, and timely services for your trip."
    },
    {
      "name": "Book Cab in Pune",
      "description": "Book a Cab in Pune with Mauli Cabs for quick and easy access to reliable taxi services. We offer comfortable rides for all occasions, including business and leisure."
    },
    {
      "name": "Pune to Aurangabad Taxi",
      "description": "Book a Pune to Aurangabad Taxi for a convenient, comfortable, and safe trip. Our taxis are ideal for pilgrimage, business, or leisure trips to Aurangabad."
    },
    {
      "name": "Pune to Mumbai Cab Booking",
      "description": "Book your Pune to Mumbai Cab quickly and easily. Whether it's a one-way trip or round trip, we offer affordable rates and reliable services."
    },
    {
      "name": "Pune Mumbai Cabs",
      "description": "Choose Pune Mumbai Cabs for a smooth and timely ride between Pune and Mumbai. Our vehicles provide comfort and convenience for both business and leisure travelers."
    },
    {
      "name": "Outstation Car Rental Pune",
      "description": "Book Outstation Car Rental in Pune for long-distance travel. Our fleet includes vehicles for both short trips and extended journeys to nearby destinations."
    },
    {
      "name": "Pune to Mumbai Cab One Way",
      "description": "Need a one-way ride from Pune to Mumbai? Book a Pune to Mumbai Cab One Way for an affordable and hassle-free journey with Mauli Cabs."
    },
    {
      "name": "Pune Taxi Hire Outstation",
      "description": "Book a Pune Taxi Hire for Outstation travel. Our cabs provide comfort, safety, and timely service for long-distance trips to nearby cities."
    },
    {
      "name": "Pune Taxi Hire Outstation Cost",
      "description": "Learn about Pune Taxi Hire Outstation Costs with Mauli Cabs. We provide competitive pricing and transparent rates for your long-distance travels."
    },
    {
      "name": "Pune to Mahabaleshwar Tour Package",
      "description": "Book a Pune to Mahabaleshwar Tour Package for a complete travel experience. Enjoy a convenient and comfortable trip with sightseeing, meals, and more."
    },
    {
      "name": "Pune to Mahabaleshwar Package for 2 Days",
      "description": "Plan a 2-day Pune to Mahabaleshwar Package with Mauli Cabs. Enjoy a relaxing getaway with sightseeing, transportation, and accommodation services."
    }
  ],
  "tableData": [
    ["Pune Airport Taxi Hire", "Pune Corporate Taxi Hire"],
    ["Luxury Taxi Hire Pune", "Pune Outstation Taxi Hire"],
    ["Pune Local Taxi Rentals", "Pune Wedding Taxi Service"],
    ["Pune Taxi Hire for Tours", "Economy Taxi Hire Pune"],
    ["Pune Taxi Hire for Events", "Pune 24/7 Taxi Service"],
    ["Pune Taxi Hire", "Pune to Mumbai Airport Cab"],
    ["Pune to Mumbai Cabs", "Pune to Mumbai Cheapest Cab"],
    ["Pune to Mumbai Cab Service", "Cab from Pune to Mahabaleshwar"],
    ["Taxi From Pune to Mahabaleshwar", "Book Cab in Pune"],
    ["Pune to Aurangabad Taxi", "Pune to Mumbai Cab Booking"],
    ["Pune Mumbai Cabs", "Outstation Car Rental Pune"],
    ["Pune to Mumbai Cab One Way", "Pune Taxi Hire Outstation"],
    ["Pune Taxi Hire Outstation Cost", "Pune to Mahabaleshwar Tour Package"],
    ["Pune to Mahabaleshwar Package for 2 Days", ""]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Reliable and Timely Service",
        "WhyChoosedescription": "Mauli Cabs offers reliable and timely service for all your Pune Taxi Hire needs. Whether you're heading to the airport, a business meeting, or a weekend getaway, our professional drivers ensure timely pickups and drop-offs for a smooth and stress-free experience."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "Our fleet of vehicles includes comfortable and spacious sedans, SUVs, and premium cars, all designed to make your journey pleasant. Each vehicle is air-conditioned and regularly maintained to ensure a comfortable ride throughout your taxi hire in Pune."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "At Mauli Cabs, our experienced and professional drivers know the city of Pune like the back of their hand. They provide a safe and smooth ride, navigating the busy roads with ease and ensuring you have a pleasant experience during your taxi hire."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Mauli Cabs offers competitive and transparent pricing for your Pune Taxi Hire. We provide clear and upfront pricing with no hidden charges, ensuring that you get great value for your money without any surprises."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Safety is our top priority. All our vehicles are equipped with modern safety features like airbags, seat belts, and GPS tracking. Our drivers adhere to strict safety protocols, ensuring you have a secure and comfortable journey every time you hire a taxi in Pune."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Mauli Cabs is available 24/7 for your Pune Taxi Hire needs. Whether you need a ride early in the morning or late at night, our customer service team is always ready to assist you with booking your taxi at any time."
    },
    {
        "WhyChooseheading": "Easy and Hassle-Free Booking",
        "WhyChoosedescription": "Booking your Pune taxi with Mauli Cabs is quick and easy. You can book online via our website or mobile app, or reach out to our customer service team for personalized assistance and a smooth booking process."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "Mauli Cabs offers customized travel packages for your Pune Taxi Hire. Whether you need a taxi for local sightseeing, an airport transfer, or a longer outstation journey, we can tailor the service to meet your specific travel needs and preferences."
    }
]












    }



    const faqData = [
        {
            question: 'How do I hire a taxi in Pune with Mauli Cabs?',
            answer: 'Hiring a taxi in Pune with Mauli Cabs is simple! You can book a taxi directly through our website or mobile app. Just enter your pickup location and destination, select the vehicle that suits your needs, and confirm your booking. Alternatively, you can call our customer support team for assistance.',
        },
        {
            question: 'What types of taxis are available for hire in Pune?',
            answer: 'Mauli Cabs offers a variety of taxis for hire in Pune, including Sedans, SUVs, Ertiga, Innova Crysta, and premium options. Whether you need a taxi for a short trip within the city or a longer journey, we have the perfect vehicle for you.',
        },
        {
            question: 'Is the fare for hiring a taxi in Pune fixed?',
            answer: 'Yes, the fare for hiring a taxi in Pune is fixed and transparent. The fare includes tolls, taxes, and driver charges, with no hidden costs. The total fare will be provided upfront before confirming your booking.',
        },
        {
            question: 'Can I hire a taxi for a round trip in Pune?',
            answer: 'Yes, you can easily hire a taxi for a round trip in Pune. Just provide your return details when making the booking, and we’ll ensure a smooth return journey to your destination.',
        },
        {
            question: 'How long does it take to hire a taxi within Pune?',
            answer: 'Taxi travel times within Pune depend on the distance and traffic conditions. For short trips within the city, it typically takes between 20 minutes to an hour. Our experienced drivers know the best routes to ensure timely arrivals.',
        },
        {
            question: 'Are the taxi drivers experienced and professional?',
            answer: 'Yes, all Mauli Cabs drivers are professional, experienced, and well-trained. They are familiar with Pune’s local routes and ensure a safe, comfortable, and pleasant journey for you.',
        },
        {
            question: 'Are the taxis air-conditioned and well-maintained?',
            answer: 'Yes, all our taxis are fully air-conditioned and well-maintained to ensure cleanliness and comfort. We prioritize hygiene and ensure your ride is comfortable and enjoyable.',
        },
        {
            question: 'Can I make stops for sightseeing while hiring a taxi in Pune?',
            answer: 'Yes, you can customize your taxi ride by making stops for sightseeing or taking breaks along the way. Whether you want to visit popular spots like Shaniwar Wada or the Aga Khan Palace, our drivers will accommodate your requests.',
        },
        {
            question: 'Can I cancel or modify my taxi booking after confirmation?',
            answer: 'Yes, you can cancel or modify your taxi booking after confirmation. We offer a flexible cancellation policy through our website or app, and our customer support team is always available to assist you.',
        },
        {
            question: 'Why should I hire a taxi from Mauli Cabs in Pune?',
            answer: 'Mauli Cabs offers reliable service, competitive pricing, a wide range of vehicles, and professional drivers. Whether you need a taxi for a city ride or a long-distance trip, we ensure a comfortable, stress-free, and pleasant experience.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Arvind Patil",
            position: "Corporate Executive",
            text: "I regularly hire taxis from Mauli Cabs for my business meetings around Pune. The service is always prompt, the taxis are clean and comfortable, and the drivers are professional. I can always count on them for my transport needs.",
            image: "/img/testimonial/testimonial-thumb-1-1.png",
        },
        {
            name: "Miss. Radhika Sharma",
            position: "Tourist",
            text: "I hired a taxi from Mauli Cabs for a sightseeing tour in Pune. The taxi was spacious, well-maintained, and comfortable, and the driver was very knowledgeable about the city's landmarks. It was a wonderful experience, and I highly recommend their services!",
            image: "/img/testimonial/testimonial-thumb-1-2.png",
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune Taxi Hire by Mauli Cabs",
        "description": "Mauli Cabs offers a range of taxi hire services in Pune, including airport transfers, corporate taxis, luxury taxis, outstation rentals, wedding services, and more. Whether for local travel, tours, events, or outstation trips like Mumbai, Mahabaleshwar, and Aurangabad, book your reliable and affordable taxi with 24x7 online booking support.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.7",
          "ratingCount": "4100"
        }
      };
      
      
      


    return (
        <div>
            <GTag/>

<Helmet>
        <title>Pune Taxi Hire | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book your Pune Taxi Hire with Mauli Cabs. We offer airport transfers, corporate taxis, luxury taxis, outstation car rentals, and more for local and intercity travel. Enjoy comfortable rides to destinations like Mumbai, Mahabaleshwar, Aurangabad, and beyond with 24x7 online booking."
        />
        <meta
          name="keywords"
          content="Pune Airport Taxi Hire, Pune Corporate Taxi Hire, Luxury Taxi Hire Pune, Pune Outstation Taxi Hire, Pune Local Taxi Rentals, Pune Wedding Taxi Service, Pune Taxi Hire for Tours, Economy Taxi Hire Pune, Pune Taxi Hire for Events, Pune 24/7 Taxi Service, Pune Taxi Hire, Pune to Mumbai Airport Cab, Pune to Mumbai Cabs, Pune to Mumbai Cheapest Cab, Pune to Mumbai Cab Service, Cab from Pune to Mahabaleshwar, Taxi From Pune to Mahabaleshwar, Book Cab in Pune, Pune to Aurangabad Taxi, Pune to Mumbai Cab Booking, Pune Mumbai Cabs, Outstation Car Rental Pune, Pune to Mumbai Cab One Way, Pune taxi hire outstation, Pune taxi hire outstation cost, Pune to Mahabaleshwar tour package, Pune to Mahabaleshwar package for 2 days"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>


            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/32.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetaxihire;